import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-email-required-modal',
  templateUrl: './email-required-modal.component.html',
  styleUrls: ['./email-required-modal.component.scss'],
})
export class EmailRequiredModalComponent {
  email = new FormControl('', [Validators.required, Validators.email]);
  saving = false;
  submitted = false;
  errorMessage: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<EmailRequiredModalComponent>,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; message: string; confirmText: string; cancelButton: string }
  ) {}

  async save(): Promise<void> {
    this.submitted = true;

    if (this.email.invalid) {
      return;
    }

    this.saving = true;
    this.errorMessage = null;
    try {
      await this.userService.updateProfile({ user: { primary_email: this.email.value! } });
      this.userService.clearUserCache();
      this.dialogRef.close(this.email.value);
    } catch (error) {
      this.errorMessage = 'EmailRequiredToJoinCaseSaveFailed';
    } finally {
      this.saving = false;
    }
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
